import { CampaignState, RootState } from "../types";
import { GetterTree, ActionTree, MutationTree, Module } from "vuex";
import { FETCH_CAMPAIGN_DATA } from "./actions.names";
import { API_URL } from "../global";
import axios from "axios";
import { SET_CAMPAIGN_DATA, SET_CAMPAIGN_DATA_ERROR } from "./mutations.names";
import Vue from "vue";

export const state: CampaignState = {
  data: [],
  error: false,
};

const namespaced: boolean = false;

const getters: GetterTree<CampaignState, RootState> = {
  campaignData(state) {
    // if (!state) {
    //   return undefined;
    // }
    return state.data;
  }
};

const actions: ActionTree<CampaignState, RootState> = {
  async [FETCH_CAMPAIGN_DATA]({ commit }, id: number): Promise<any> {
    axios
      .get(
        `${API_URL}/pages/?child_of=${id}&type=pages.CampaignIndexPage&fields=header,body`
      )
      .then(({ data }) => {
        commit(SET_CAMPAIGN_DATA, data.items);
      })
      .catch((err: any) => {
        commit(SET_CAMPAIGN_DATA_ERROR);
      });
  }
};

const mutations: MutationTree<CampaignState> = {
  [SET_CAMPAIGN_DATA](state, payload): any {
   // console.log(payload);
    Vue.set(state, 'data', payload);
    // state.data = payload;
    state.error = false;
   // console.log(state);
  },
  [SET_CAMPAIGN_DATA_ERROR](state: any): any {
    state.data = [];
    state.error = true;
  }
};

export const campaignData: Module<CampaignState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
